export default "__VITE_ASSET__Cj1SzW17__"